module.exports = __webpack_public_path__ + "img/couples-070.3b6bc42f.jpg";